'use strict';

require('react');
var createTheme = require('./createTheme.cjs');
var createTypography = require('./createTypography.cjs');
var identifier = require('./identifier.cjs');
var InitColorSchemeScript = require('../InitColorSchemeScript/InitColorSchemeScript.cjs');
require('react/jsx-runtime');
var createCssVarsProvider = require('../../node_modules/@mui/system/esm/cssVars/createCssVarsProvider.cjs');
var styleFunctionSx = require('../../node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.cjs');

const {
  CssVarsProvider: InternalCssVarsProvider,
  useColorScheme,
  getInitColorSchemeScript: deprecatedGetInitColorSchemeScript
} = createCssVarsProvider.default({
  themeId: identifier,
  // @ts-ignore ignore module augmentation tests
  theme: () => createTheme({
    cssVariables: true
  }),
  colorSchemeStorageKey: InitColorSchemeScript.defaultConfig.colorSchemeStorageKey,
  modeStorageKey: InitColorSchemeScript.defaultConfig.modeStorageKey,
  defaultColorScheme: {
    light: InitColorSchemeScript.defaultConfig.defaultLightColorScheme,
    dark: InitColorSchemeScript.defaultConfig.defaultDarkColorScheme
  },
  resolveTheme: theme => {
    const newTheme = {
      ...theme,
      typography: createTypography(theme.palette, theme.typography)
    };
    newTheme.unstable_sx = function sx(props) {
      return styleFunctionSx.default({
        sx: props,
        theme: this
      });
    };
    return newTheme;
  }
});

/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */
const CssVarsProvider = InternalCssVarsProvider;

exports.CssVarsProvider = CssVarsProvider;
exports.useColorScheme = useColorScheme;
//# sourceMappingURL=ThemeProviderWithVars.cjs.map
